import React, {useEffect, useState} from "react";
import {
	addClient,
	addTrainer,
	checkForQuestionnaire,
	createAnalysis,
	deleteNewestQuestionnaire,
	getAllLicenses,
	getAllProducts,
	getTrainer,
	getTrainers,
	getUserData,
	issueQuestionnaire,
	removeClient,
	setTrainerEnabled,
	setTrainerPassword,
	updateClient,
	updateTrainer
} from "./KairosEndpoint";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Route, Switch} from "react-router-dom";
import AdminRoot, {adminRoutes} from "./AdminRoot";
import TrainerRoot, {trainerRoutes} from "./TrainerRoot";
import BreadCrumb from "./util/BreadCrumb";
import RoutingChangePassword from "./util/RoutingChangePassword";
import RoutingKairogramm from "./client/RoutingKairogramm";
import {Header} from "./Header";


export const Authorized = ({
	showInfo,
	showError,
}) => {
	const [productData, setProductData] = useState();
	const [userData, setUserData] = useState();
	const [trainers, setTrainers] = useState();

	// determine userData

	useEffect(() => {
		(async () => {
			try {
				let allLicenses = await getAllLicenses();
				let allProducts = await getAllProducts();

				setProductData({
					allLicenses: allLicenses,
					allProducts: allProducts,
				})

				let userData = await getUserData();
				setUserData(userData);

				// retrieve trainer/s
				switch (userData.role) {
					case 'ROLE_ADMIN': {
						await (async () => {
							try {
								let trainers = await getTrainers();
								setTrainers(trainers);
							} catch (e) {
								showError(e);
							}
						})();
						break;
					}
					case 'ROLE_TRAINER': {
						await (async () => {
							try {
								let trainer = await getTrainer(userData.trainerId);
								setTrainers([trainer]);
							} catch (e) {
								showError(e);
							}
						})();
						break;
					}
				}
			}
			catch (e) {
				console.log(`error: ${e.message}`);
			}
		}) ();
	}, []);

	if (!userData || !productData || !trainers)
		return (
			<Row>
				<Col>
					{'... lädt'}
				</Col>
			</Row>
		);


	// handle updates from admin/trainer root

	// trainers

	const handleCreateTrainer = async newTrainer => {
		try {
			console.log(`created a trainer`);
			const createdTrainer = await addTrainer(newTrainer);

			setTrainers(trainers => trainers.concat([createdTrainer]));
			return createdTrainer;
		}
		catch (e) {
			showError(e);
		}
	};

	const handleSetTrainerEnabled = async (id, enabled) => {
		try {
			const updatedTrainer = await setTrainerEnabled(id, enabled);

			setTrainers(trainers => trainers.map(t => t.id === id ? updatedTrainer : t));
		}
		catch (e) {
			showError(e);
		}
	};

	const handleUpdateTrainer = async (trainerId, trainerUpdate) => {
		// merge trainer updates into our trainer list
		try {
			console.log(`updated a trainer`);
			const updatedTrainer = await updateTrainer(trainerId, trainerUpdate);

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));
			return updatedTrainer;
		}
		catch (e) {
			showError(e);
		}
	};

	const handleSetTrainerPassword = async (trainer, password) => {
		try {
			await setTrainerPassword(trainer, password);
		}
		catch (e) {
			showError(e);
		}
	};


	// client

	const handleCreateClient = async (trainerId, newClient) => {
		// merge trainer updates into our trainer list
		try {
			console.log(`updated a trainer`);
			const trainer = trainers.find(t => t.id === trainerId);
			const updatedTrainer = await addClient(trainerId, newClient);

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));

			return updatedTrainer.clients
				.map(c => c.id)
				.filter(id => !(trainer.clients.map(c => c.id).includes(id)))
				[0];
		}
		catch (e) {
			showError(e);
		}
	};

	const handleUpdateClient = async (trainerId, clientId, clientUpdate) => {
		try {
			const updatedClient = await updateClient(trainerId, clientId, clientUpdate);
			console.log('updated a client')

			const trainer = trainers.find(t => t.id === trainerId);
			const updatedTrainer = {
				...trainer,
				clients: trainer.clients.map(c => c.id === clientId ? updatedClient : c),
			}

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));

			// setAction();
		}
		catch (e) {
			showError(e);
		}
	}

	const handleRemoveClient = async (trainerId, removedClient) => {
		// merge trainer updates into our trainer list
		try {
			console.log(`updated a trainer`);
			const updatedTrainer = await removeClient(trainerId, removedClient);

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));
		}
		catch (e) {
			showError(e);
		}
	};

	const handleCheckForQuestionnaire = async (trainerId, client, questionnaireType) => {
		try {
			const updatedClient = await checkForQuestionnaire(client, questionnaireType);

			if (updatedClient) {
				const trainer = trainers.find(t => t.id === trainerId);
				const updatedTrainer = {
					...trainer,
					clients: trainer.clients.map(c => c.id === client ? updatedClient : c),
				}

				setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));

				return updatedClient;
			}
		}
		catch (e) {
			showError(e);
		}
	};

	const handleIssueQuestionnaire = async (trainerId, client, questionnaireType) => {
		try {
			const updatedClient = await issueQuestionnaire(client, questionnaireType);

			const trainer = trainers.find(t => t.id === trainerId);
			const updatedTrainer = {
				...trainer,
				clients: trainer.clients.map(c => c.id === client ? updatedClient : c),
			}

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));
		}
		catch (e) {
			showError(e);
		}
	};

	const handleDeleteQuestionnaire = async (trainerId, client, questionnaireType) => {
		try {
			const updatedClient = await deleteNewestQuestionnaire(client, questionnaireType);

			const trainer = trainers.find(t => t.id === trainerId);
			const updatedTrainer = {
				...trainer,
				clients: trainer.clients.map(c => c.id === client ? updatedClient : c),
			}

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));
		}
		catch (e) {
			showError(e);
		}
	}


	// analyses

	const handleCreateAnalysis = async (trainerId, clientId, date, analysis) => {
		try {
			const updatedClient = await createAnalysis(clientId, date, analysis);

			// find trainer and merge update into his clients
			const trainer = trainers.find(t => t.id === trainerId);
			const updatedTrainer = {...trainer};
			updatedTrainer.clients = updatedTrainer.clients.map(c => c.id === clientId ? updatedClient : c);

			setTrainers(trainers => trainers.map(t => t.id === trainerId ? updatedTrainer : t));
		}
		catch (e) {
			showError(e);
		}
	};


	let content;
	let breadcrumbData;
	let routes;
	switch (userData.role) {
		case 'ROLE_ADMIN': {
			content = (
				<AdminRoot
					showInfo = {showInfo}
					products = {userData.license.products}
					productData = {productData}
					trainers = {trainers}
					createTrainer= {handleCreateTrainer}
					setTrainerEnabled ={handleSetTrainerEnabled}
					updateTrainer={handleUpdateTrainer}
					setTrainerPassword = {handleSetTrainerPassword}
					createClient={handleCreateClient}
					removeClient={handleRemoveClient}
					updateClient={handleUpdateClient}
					issueQuestionnaire = {handleIssueQuestionnaire}
					checkForQuestionnaire={handleCheckForQuestionnaire}
					deleteNewestQuestionnaire = {handleDeleteQuestionnaire}
					createAnalysis={handleCreateAnalysis}/>
			);
			breadcrumbData = trainers;
			routes = appRoutes.concat(adminRoutes);
			break;
		}
		case 'ROLE_TRAINER': {
			content = (
				<TrainerRoot
					showInfo = {showInfo}
					products = {userData.license.products}
					productData = {productData}
					trainer = {trainers[0]}
					updateTrainer={handleUpdateTrainer}
					createClient={handleCreateClient}
					removeClient={handleRemoveClient}
					updateClient={handleUpdateClient}
					issueQuestionnaire = {handleIssueQuestionnaire}
					checkForQuestionnaire={handleCheckForQuestionnaire}
					createAnalysis={handleCreateAnalysis}/>
			);
			breadcrumbData = trainers;
			routes = appRoutes.concat(trainerRoutes);
			break;
		}
	}



	// render

	return (
		<>
			<Header
				userData = {userData}/>
			<Switch>
				{/* kairogramm */}
				<Route path = {'/print-kairogramm/:clientId/kairogramm/:kairogrammId'}
					render = {routeProps => {
						const clientId = routeProps.match.params.clientId;
						const client = trainers
						.map(t => t.clients)
						.flat()
						.find(c => c.id === clientId);

						return (
							<RoutingKairogramm
								client = {client}
							print/>
						);
					}}/>

				<Route>
					{/* breadcrumb */}
					<Row className = {'my-3'}>
						<Col>
							<BreadCrumb
								routes = {routes}
								data = {breadcrumbData}/>
						</Col>
					</Row>

					{/* content */}
					<Row>
						<Col>
							<Switch>
								{/* change password */}
								<Route path = {'/changePassword'}>
									<RoutingChangePassword
										showInfo = {showInfo}/>
								</Route>

								{/* user-dependant content */}
								<Route path = {'/'}>
									{content}
								</Route>
							</Switch>
						</Col>
					</Row>
				</Route>
			</Switch>
		</>
	);
};

const appRoutes = [
	{
		path: '/',
		crumble: () => [{
			text: 'Startseite',
			href: '/',
		}],
	},
	{
		path: '/impressum',
		crumble: () => [
			{
				text: 'Startseite',
				href: '/',
			},
			{
				text: 'Impressum',
				href: '/',
			}
		],
	},
	{
		path: '/datenschutz',
		crumble: () => [
			{
				text: 'Startseite',
				href: '/',
			},
			{
				text: 'Datenschutz',
				href: '/',
			}
		],
	},
	{
		path: '/changePassword',
		crumble: () => [
			{
				text: 'Startseite',
				href: '/',
			},
			{
				text: 'Passwort ändern',
				href: '/changePassword'
			},
		]
	}
];
